export { authStore, getAuthHeaders, isDevAuthEnabled, onSignOut, setAuthState, signOutLocally, type AuthState } from './store';
export { getSessionId, resetSessionId } from './session';
export { signInWithCognito, ensureFreshIdToken, signOutCognito, isCognitoConfigured, COGNITO_REGION } from './cognito';
export { fetchDevPrincipals, signInAsDevPrincipal } from './dev';

import { signOutCognito } from './cognito';
import { signOutLocally } from './store';

/** User-initiated sign-out: notifies listeners (mic + audio stop), clears tokens and the session id. */
export function signOut(): void {
  signOutCognito();
  signOutLocally('user');
}
